const translations = {
  'careerService.seo.title': 'Ayuda para encontrar trabajos de TEFL en Barcelona y Sevilla',
  'careerService.seo.description':
    'TEFL Iberia tiene un servicio de atención al estudiante único y dedicado para ayudar a nuestros docentes egresados a encontrar buenos trabajos TEFL. Saber más.',
  'careerService.sec1.title': 'Servicio de Orientación Profesional',
  'careerService.sec2.title': 'Desbloquea un mundo de nuevas posibilidades',
  'careerService.sec2.description':
    'La enseñanza de inglés tiene gran demanda a nivel mundial. Entre los innumerables posibles caminos profesionales, completar un curso Trinity CertTESOL te permitirá: ',
  'careerService.sec2.ben1.title': 'Trabajar en una academia de idiomas',
  'careerService.sec2.ben1.text':
    'Enseñar inglés a adultos o niños en las mejores academias de idiomas y escuelas de ESL aquí en Barcelona o en cualquier otro lugar del mundo.',
  'careerService.sec2.ben2.title': 'Enseñar clases de negocios',
  'careerService.sec2.ben2.text':
    'El inglés es el idioma de los negocios internacionales, lo que ha creado trabajo proporcionando instrucción interna a los empleados de negocios.',
  'careerService.sec2.ben3.title': 'Dar clases particulares o enseñar de forma privada',
  'careerService.sec2.ben3.text':
    'Establece tu propio horario como profesor/a de inglés enfocado en adultos, niños en edad escolar, adolescentes o inmigrantes.',
  'careerService.sec2.ben4.title': 'Encontrar trabajo en línea',
  'careerService.sec2.ben4.text':
    'Gracias a las maravillas de la world wide web, hay muchas oportunidades para enseñar inglés en línea a estudiantes de todo el mundo.',
  'careerService.sec2.ben5.title': '98%',
  'careerService.sec2.ben5.text':
    'Tasa de aprobación total de todos los estudiantes de TEFL desde 2012.',
  'careerService.sec2.ben6.title': '1500€',
  'careerService.sec2.ben6.text': 'Ingreso mensual promedio para nuevos profesores de inglés.',
  'careerService.sec2.ben7.title': '2 semanas ',
  'careerService.sec2.ben7.text':
    'Tiempo aproximado en el que nuestros estudiantes graduados encuentran empleo.',
  'careerService.sec3.title': 'Encuentra El Trabajo De Tus Sueños Con TEFL Iberia  ',
  'careerService.sec3.description':
    'En TEFL Iberia, hacemos más que simplemente equiparte con una educación líder en la industria de inglés, acreditada por Trinity College London. También te equipamos con las habilidades, la orientación y las conexiones que necesitas para encontrar trabajo remunerado en cuestión de semanas después de completar tu curso.',
  'careerService.sec3.benefitsTitle': 'Nuestra preparación y apoyo posterior al curso incluye:',
  'careerService.sec3.ben1': 'Sesión de orientación del mercado laboral.',
  'careerService.sec3.ben2': 'Taller de preparación de CV.',
  'careerService.sec3.ben3': 'Preparación y práctica de entrevistas.',
  'careerService.sec3.ben4': 'Acceso exclusivo a nuestra base de datos de empleadores.',
  'careerService.sec3.ben5': 'Acceso exclusivo a la bolsa de trabajo de TEFL Iberia.',
  'careerService.sec4.title': 'Los estudiantes egresados de TEFL Iberia trabajan en: ',
  'careerService.sec7.title':
    '¿Listo para dar los primeros pasos hacia <accent>tu nueva carrera?</accent>',
  'careerService.sec7.description':
    'Ahora es más fácil que nunca convertirse en un profeso/ar internacional de inglés. Aplica ahora y comienza a trabajar en tu empleo soñado hoy mismo.',
  'careerService.graduates.title':
    'Hemos Ayudado A Cientos De Estudiantes A Certificarse Y Encontrar Trabajo En España. ¿Quieres Ser El/La Siguiente?',
};

export default translations;
